import React from 'react';

const HealthCheck = () => <div>Hello! The app is healthy!</div>;

export default HealthCheck;
